//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getNewEmail, sendEmail, cocReport } from "@/api/index";

export default {
  mounted() {
    this.$vux.loading.show({
      text: "加载中..."
    });
    //上个页面传过来的COC报告接口的参数
    let t = this,
      barcode = t.$route.query.barcode,
      iccBatchNo = t.$route.query.iccBatchNo,
      basetype = t.$route.query.basetype;
    //获取COC报告接口数据
    cocReport({
      barcode,
      iccBatchNo,
      basetype
    }).then(res => {
      this.$vux.loading.hide();
      t.cocDetailDto = res.data.data.cocDetailDto;
      if (res.data.code === 0) {
        t.seal = res.data.data.cocDetailDto.seal;
        t.barcode = res.data.data.cocDetailDto.iccBarcode;
      } else {
        t.$vux.toast.text(
          res.data.msg + "详情请联系林德服务中心400-820-1798",
          "middle"
        );
      }
    });
    //判断邮箱是获取的最新邮箱还是手动选择的邮箱
    if (!this.email) {
      //最新邮箱
      getNewEmail().then(res => {
        if (res.data.code === 0) {
          t.emailAddress = res.data.data.email.emailAddress;
        } else {
          t.$vux.toast.text(res.data.msg, "middle");
        }
      });
    } else {
      //用户手动选择的邮箱
      this.emailAddress = this.email.emailAddress;
    }
  },
  data() {
    return {
      cocDetailDto: null,
      emailAddress: "填写邮箱",
      seal: "",
      subjectBody: "",
      barcode: ""
    };
  },
  computed: {
    //用户选择的邮箱
    email() {
      return this.$store.state.email;
    }
  },
  methods: {
    //选择其他邮箱
    selectEmail() {
      let t = this;
      t.$router.push("/selectEmail");
    },
    //发送邮件并重新扫码
    sendEmail() {
      let t = this,
        barcode = t.cocDetailDto.iccBarcode,
        iccBatchNo = t.cocDetailDto.batchNo,
        basetype = t.cocDetailDto.basetype,
        htmlBody = escape(
          "https://ecoa2.lindemobile.cn/pc/#/pc/certificateApprovalEmail?barcode=" +
            barcode +
            "&iccBatchNo=" +
            iccBatchNo +
            "&basetype=" +
            basetype
        );
      if (basetype === 0) {
        let orderTime = sessionStorage.getItem("cocOrderTime"),
          orderId = sessionStorage.getItem("cocOrderId");
        t.subjectBody = "林德产品合格证-" + orderId + "-" + orderTime;
      } else {
        t.subjectBody = `林德产品合格证-${t.barcode}`;
      }
      sendEmail({
        htmlBody,
        address: t.emailAddress,
        subjectBody: t.subjectBody
      }).then(res => {
        if (res.data.code === 0) {
          t.$vux.toast.text("发送成功", "middle");
          setTimeout(() => {
            t.$router.push("/certificateApproval");
          }, 2000);
        } else {
          t.$vux.toast.text(res.data.msg, "middle");
        }
      });
    },
    //继续扫描
    continueScan() {
      let t = this;
      t.$router.push("/certificateApproval");
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/COC/certificateDetail.vue